  <template>
  <div>
    <common-dialog ref="dialog" unit="已下达工单用料" width="1300px" id-key="UserId" @close-saved="$emit('close-saved')" @closed="$emit('onClosed')"
      @details-opened="detailsOpened">
      <template slot="form">
        <el-row style="text-align: center; margin: 15px">
          <el-col :span="6">
            <div>
              <span>库存仓：</span>
              <el-select style="width: 180px" v-model="WarehouseId" clearable>
                <el-option v-for="item in warehouseList1" :key="item.key" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="6">
            <div>
              <span>需求类别：</span>
              <el-select style="width: 180px" v-model="SummaryType">
                <el-option label="按工单汇总" value='0'> </el-option>
                <el-option label="按日生产汇总" value='1'> </el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="6">
            <el-button type="primary" @click="onQuery">查询</el-button>
            <el-button type="primary" @click="onPrint">打印</el-button>
          </el-col>
        </el-row>
        <el-table ref="table" class="table_bottom table-line tb-c-head" :data="tableData" border>
          <el-table-column prop="ProductNo" label="材料编号" align="center">
          </el-table-column>
          <el-table-column prop="ProductName" label="材料名称" min-width="126" align="center">
          </el-table-column>
          <el-table-column prop="ProductSpec" label="规格型号" min-width="126" align="center">
          </el-table-column>
          <el-table-column prop="ProcessStageName" label="加工阶段" min-width="110" align="center">
          </el-table-column>
          <el-table-column prop="Quantity" label="需求数量" min-width="110" align="center">
          </el-table-column>
          <el-table-column prop="WarehouseQuantity2" label="车间仓数量" min-width="110" align="center">
          </el-table-column>
          <el-table-column prop="WarehouseQuantity1" label="库存仓数量" min-width="110" align="center">
          </el-table-column>
          <el-table-column prop="ShouldQuantity" label="应领数量" min-width="110" align="center">
          </el-table-column>
          <el-table-column prop="CanQuantity" label="可领数量" min-width="110" align="center">
          </el-table-column>
        </el-table>
      </template>

      <template slot="footer">
        <el-button @click="close">关闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },

  data() {
    return {
      api: require("@/api/production/workDoc").default,
      warehouseApi: require("@/api/ba/warehouse").default,
      WorkDocIds:[],
      warehouseList: [],
      tableData: [],
      WarehouseId: null,
      SummaryType: '1',
      summaryShow: false,
      total: null,
      warehouseList1:[]
    };
  },
  methods: {
    detailsOpened(data) {
      this.WorkDocIds = data
      const o = {
        Ids: data,
        SummaryType: this.SummaryType,
      }

      this.api.GetDailyDocInfoList(o).then((res) => {
        console.log("GetDailyDocInfoList", res);
        if (res.Code === 0) {
          this.tableData = res.Data;
        }
      });

      this.warehouseApi.list({ Status: 1, WarehouseType: 1 }).then((res) => {
        if (res.Code === 0) {
          if (this.viewType === 'create') {
            this.data.GeneralWarehouseId = res.Data[0].WarehouseId;
            this.data.GeneralWarehouseName = res.Data[0].WarehouseName;
          }

          this.warehouseList1 = res.Data.map((item) => {
            return {
              key: item.WarehouseId,
              label: item.WarehouseName,
              value: item.WarehouseId,
            };
          });
        }
      });
    },
    onQuery(){
      const o = {
        Ids: this.WorkDocIds,
        WarehouseId: this.WarehouseId,
        SummaryType: this.SummaryType,
      }

      this.api.GetDailyDocInfoList(o).then((res) => {
        if (res.Code === 0) {
          this.tableData = res.Data;
        }
      });
    },
    close() {
      this.WarehouseId = null;
      this.WorkDocId = null;
      this.warehouseList = [];
      this.$refs.dialog.close(true);
    },
    onPrint(){
      let newpage = this.$router.resolve({
        path: '/materialPrint',
        query: {
          Ids: this.WorkDocIds,
          WarehouseId: this.WarehouseId,
          SummaryType: this.SummaryType
        }
      });
      window.open(newpage.href, '_blank');
    }
  },
};
</script>
